import React from "react";
import { ButtonNew as Button } from "components/buttonNew";
import Layout from "components/layout/index";
import { useHistory, Link } from "react-router-dom";

import Page from "components/page/Page";
import Card from "components/card/Card";

import Category from "elements/settings/Category";

import { useTranslation, Trans } from "react-i18next";

const TeeSheetSettings = () => {
  const { t, i18n } = useTranslation();
  const options = [
    {
      label: t("General"),
      description: t("General tee sheet information"),
      url: "/admin/settings/tee-sheet/general",
      icon: "circle",
    },
    {
      label: t("Booking Engines"),
      description: t("View and edit your booking engines"),
      url: "/admin/settings/tee-sheet/booking-engine",
      icon: "circle",
    },
    {
      label: t("Templates"),
      description: t("Build new tee sheet templates"),
      url: "/admin/settings/tee-sheet/template",
      icon: "table",
    },
    {
      label: t("Calendar"),
      description: t("View tee sheets applied throughout the season"),
      url: "/admin/settings/tee-sheet/calendar",
      icon: "calendar",
    },
    {
      label: t("Pricing Sheets"),
      description: t("Build pricing sheets for tee time bookings"),
      url: "/admin/settings/tee-sheet/pricing-sheet",
      icon: "dollar",
    },
    {
      label: t("Check In Configuration"),
      description: t("Set check in configurations for various customer types"),
      url: "/admin/settings/tee-sheet/check-in-config",
      icon: "dollar",
    },
    {
      label: t("Customer Type Configuration"),
      description: t("Set type configurations for various customer types"),
      url: "/admin/settings/tee-sheet/customer-type-config",
      icon: "",
    },
  ];

  return (
    <Page
      title={t("Tee Sheets")}
      narrow
      breadcrumbs={[{ label: t("Settings"), url: "/admin/settings" }]}
    >
      <Card>
        <Card.Section>
          {options.map((option: any, index: number) => {
            return <Category key={index} label={option.label} url={option.url} />;
          })}
        </Card.Section>
      </Card>
    </Page>
  );
};

export default TeeSheetSettings;
